@use '../../scss/utility/functions' as utility;

:host {
  // fill color of the svg
  --fill: initial;

  display: inline-block;
  vertical-align: middle;
  width: utility.wb-pixel-to-rem(24px);
  height: utility.wb-pixel-to-rem(11px);

  // patch for Safari browser
  svg {
    width: 100%;
  }

  .label {
    fill: var(--wb-white);
  }

  .shape {
    fill: var(--fill);
  }
}

:host([rating='A']),
:host([rating='A+']),
:host([rating='A+++']),
:host([rating='A++']) {
  --fill: #009e46;
}

:host([rating='B']) {
  --fill: #67b633;
}

:host([rating='C']) {
  --fill: #d2d700;
}

:host([rating='D']) {
  --fill: #ffed00;
}

:host([rating='F']) {
  --fill: #f17e04;
}

:host([rating='E']) {
  --fill: #fdc602;
}

:host([rating='G']) {
  --fill: #eb2220;
}

:host([country='DE'][rating='A+++']),
:host([country='DE'][rating='A++']) {
  --fill: #009640;
}

:host([country='DE'][rating='A+']) {
  --fill: #52ae32;
}

:host([country='DE'][rating='A']),
:host([country='DE'][rating='B']) {
  --fill: #c8d400;
}

:host([country='DE'][rating='C']) {
  --fill: #ffed00;
}

:host([country='DE'][rating='D']) {
  --fill: #ec6608;
}

:host([country='DE'][rating='E']),
:host([country='DE'][rating='F']),
:host([country='DE'][rating='G']) {
  --fill: #e30613;
}
